// extracted by mini-css-extract-plugin
module.exports = {"container":"collection-preview_container__3Kuj9","placeholder":"collection-preview_placeholder__Ln0sn"};